import GetWithProgress from "partners/utils/get_with_progress"

import * as $ from "jquery"

export default function AdminActions() {
  let reEnable = el => {
    el.html("Save").attr("disabled", false)
  }

  $(".add-admin button").click(function () {
    $(".admin-new").show()
    $(".add-admin button").hide()
  })

  $(".admins li button[data-load-form-async]").click(e => {
    $(".admins li").show()
    $(".admin-new").hide()
    $(".add-admin button").show()

    let el = e.currentTarget
    if (!el.classList.contains("loading")) {
      el.classList.add("loading")
      GetWithProgress(el.dataset.href).finally(() =>
        el.classList.remove("loading")
      )
    }
  })

  $(".field-list").delegate(".cancel-field", "click", function (e) {
    e.preventDefault()
    $(".field-edit").html("")
    $(".action-inputs .add-field").show()
  })

  $(".admins-edit").delegate(
    "a[data-action=cancel-new]",
    "click",
    function (e) {
      e.preventDefault()
      $(".admin-new").hide()
      $(".add-admin button").show()
    }
  )

  $(".admins-edit").delegate(
    "a[data-action=cancel-update], [data-action=add-admin]",
    "click",
    function (e) {
      e.preventDefault()
      $(".admin-update").remove()
      $(".admins li").show()
    }
  )

  $(".admins-edit").delegate(
    "form[data-action=update-admin]",
    "submit",
    function (e) {
      e.preventDefault()
      let el = $("button[type=submit]", $(this))

      $.ajax({
        url:
          $(this).attr("action") +
          "?authenticity_token=" +
          window.encodeURIComponent(window.App.authenticityToken),
        type: "PUT",
        data: $(this).serializeArray(),
        success: () => {
          reEnable(el)
        },
        error: () => reEnable(el),
      })
    }
  )

  if ($(".admin-new").is(":visible")) {
    $(".add-admin button").hide()
  }
}
